import { CollectionIcon, FormField, useModeContext } from 'canoe';
import React from 'react';

import { StyledToggle, StyledValueBox } from 'craft/containers/Toolbox/components/StyledComponents';
import { TargetLocationsEnglishNames } from 'craft/types';

import { FieldContentSelector } from './FieldContentSelector';
import {
  CheckboxLabelToolbox,
  CollectionLocation,
  CollectionName,
  DynamicSettingsRow,
  FieldEditorContainer,
} from './StyledComponents';
import { FieldEditorPropsImpl } from './types';

export const FieldEditorToolbox = React.memo(
  ({
    isUsingCollectionField,
    onToggleCheckbox,
    targetLocation,
    usedCollection,
    errorMessage,
    onFieldSelection,
    selectedField,
    collectionEmbedLocations,
  }: FieldEditorPropsImpl) => {
    const { mode } = useModeContext();
    return (
      <FieldEditorContainer
        mode={mode}
        isActive={isUsingCollectionField}
        testId="collection-fields-wrapper"
      >
        <FormField data-cy="checkbox-row" label="" scale="small">
          <DynamicSettingsRow>
            <StyledValueBox
              isActive={isUsingCollectionField}
              isFirst
              label={
                <CheckboxLabelToolbox
                  htmlFor={`${targetLocation}-toggle-use-collection`}
                  element="label"
                  mode={mode}
                >
                  <CollectionIcon color="OnyxGray" size="s" />
                  &nbsp;&nbsp;
                  <CollectionLocation>
                    Get {TargetLocationsEnglishNames[targetLocation]} from
                  </CollectionLocation>
                  &nbsp;
                  <CollectionName>{usedCollection?.collectionName}</CollectionName>
                </CheckboxLabelToolbox>
              }
            >
              <StyledToggle
                id={`${targetLocation}-toggle-use-collection`}
                onClick={onToggleCheckbox}
                isActive={isUsingCollectionField}
                isFirst
                color="orange"
              />
            </StyledValueBox>
          </DynamicSettingsRow>
        </FormField>
        {isUsingCollectionField && (
          <FormField data-cy="field-selection" scale="small" label="">
            <FieldContentSelector
              hasError={!!errorMessage}
              selectedField={selectedField?.fieldId ?? ''}
              availableFields={collectionEmbedLocations}
              onSelectField={(fieldId: string) =>
                usedCollection &&
                onFieldSelection({
                  collectionId: usedCollection.id,
                  targetLocation,
                  fieldId,
                })
              }
            />
          </FormField>
        )}
      </FieldEditorContainer>
    );
  },
);
